import { render } from "./TasksSummary.vue?vue&type=template&id=428c870b&scoped=true"
import script from "./TasksSummary.vue?vue&type=script&lang=js"
export * from "./TasksSummary.vue?vue&type=script&lang=js"

import "./TasksSummary.vue?vue&type=style&index=0&id=428c870b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428c870b"]])

export default __exports__